<app-relatorio-container
    tituloRelatorio="Solicitação de Documentos"
    descricaoRelatorio="Ofício de solicitação de documentos pendentes"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'solicitacao-documentos-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6">
            <p class="text-sm">A solicitação é emitida para o prestador atualmente selecionado, relacionando os documentos pendentes necessários para a liberação do certificado.</p>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Solicitação" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
